import { DatePipe } from '@angular/common';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { IFiltroListaIntegracaoGtr } from '../filtro/filtro-lista-integracao-gtr';
import { UtilService } from 'src/app/service/util';
import { LogIntegracaoGtr, LogIntegracaoGtrLista } from '../interface/integracao-gtr';

@Injectable({
  providedIn: 'root'
})
export class IntegracaoGtrService {
  url = `${environment.urlApiProtheus}/wsrgtr`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {}

  lista(filtro: IFiltroListaIntegracaoGtr): Observable<LogIntegracaoGtrLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<LogIntegracaoGtrLista>(`${this.url}`, httpOptions);
  }

  postIntegracaoGtr(integracaogtr: LogIntegracaoGtr): Observable<LogIntegracaoGtr> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<LogIntegracaoGtr>(`${this.url}/${integracaogtr.CIDRETORNO}`, integracaogtr, httpOptions);
  }

}
